import { render, staticRenderFns } from "./reversal-invoice-form.vue?vue&type=template&id=8f90b0fe&"
import script from "./reversal-invoice-form.vue?vue&type=script&lang=js&"
export * from "./reversal-invoice-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports